import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  HeaderListComponent,
  PageListComponent,
} from "../../common/component/Index";
import {
  getPermissionActions,
  genaratePaginateFilterSort,
} from "../../../../helpers/functions";
import DEFINE from "../../../../constants/Define";
import PointChangeHistoryList from "./PointChangeHistoryList";

const propTypes = {};

let permisionActions = [];
const PointChangeHistory = (props) => {
  const { t, match, getListPointChangeHistory, pointChangeHistoryReducer } = props;
  const dispatch = useDispatch();
  //! State
  const { isFetching, totalCount, totalPage, pageIndex, pageSize, pointChangeHistory } =
    pointChangeHistoryReducer;

  const [params, setParams] = useState({
    pageIndex: pageIndex,
    pageSize: pageSize,
    orderByDesc: true,
    fromAccount: '',
    toAccount: '',
    createdBy: '',
    orderCode: '',
    activityCode: '',
    updatedBy: '' 
  });


  const [permisionActions] = useState(
    getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.POINT_CHANGE_HISTORY)
  );

  const pagination = {
    totalCount,
    totalPage,
    defaultCurrent: pageIndex,
    pageSize,
  };
  //! Function
  useEffect(() => {
    getListPointChangeHistory(params);
  }, [params]);

  const onTableChange = (pagination, filters, sorter) => {
    let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
    setParams(newFilters);
    getListPointChangeHistory(newFilters);
  };
  //! Render
  return (
    <Fragment>
      <PageListComponent>
        <HeaderListComponent
          path={match.path}
          groupPath={"pointchangehistory"}
          titleHeader={t("navigation.pointchangehistory")}
        />
        <PointChangeHistoryList
          loading={!isFetching}
          pointChangeHistory={pointChangeHistory}
          pagination={pagination}
          permisions={permisionActions}
          getListPointChangeHistory={getListPointChangeHistory}
          params={params}
          onChange={onTableChange}
        />
      </PageListComponent>
    </Fragment>
  );
};

PointChangeHistory.propTypes = propTypes;
export default PointChangeHistory;
